import { createTheme, ThemeProvider } from '@mui/material/styles';

{/*
  100	Thin
  200	Extra Light
  300	Light
  400	Normal
  500	Medium
  600	Semi-Bold
  700	Bold
  800	Extra Bold
  900	Black
*/}

{/*
	1.	#4a637d - A muted gray-blue.
	2.	#6c757d - A classic medium gray, often used in designs for subtle text.
	3.	#8a9ba8 - A light steel-blue shade.
	4.	#adb5bd - A very light gray often used for placeholder text.
	5.	#b0bec5 - A light gray with a hint of blue.  
*/}

{/* 
	1.	#007bff - A classic blue, vibrant and widely used for links or icons.
	2.	#4a90e2 - A softer, sky-blue shade.
	3.	#5dade2 - A lighter blue with a slightly modern feel.
	4.	#42a5f5 - A bright, medium-blue with a hint of vibrancy.
	5.	#90caf9 - A soft, pastel-like blue for a subtle look.
*/}

const theme = createTheme({
  components: {
    MuiTableCell: {
      styleOverrides: {
        root: {
          color: '#6c757d', // Default color for all TableCells
        },
      },
    },
  },
  typography: {
    fontFamily: 'Poppins, sans-serif', // Primary font
    h1: {
      fontFamily: 'Poppins, sans-serif',
      fontWeight: 700,
    },
    h2: {
      fontFamily: 'Poppins, sans-serif',
      fontWeight: 700,
    },
    h3: {
      fontFamily: 'Poppins, sans-serif',
      fontWeight: 400,
    },
    h4: {
      fontFamily: 'Poppins, sans-serif',
      fontWeight: 300,
    },
    h5: {
      fontFamily: 'Poppins, sans-serif',
      fontWeight: 300,
    },
    h6: {
      fontFamily: 'Poppins, sans-serif',
      fontWeight: 300,
    },
    body: {
      fontFamily: 'Poppins, sans-serif',
      fontWeight: 400,
    },
    body1: {
      fontFamily: 'Poppins, sans-serif',
      fontWeight: 400,
      fontSize: '1rem', // Default body text size
      lineHeight: 1.5, // Line spacing
      color: '#2c3e50', // Primary text color
    },
    body2: {
      fontFamily: 'Poppins, sans-serif',
      fontWeight: 400,
      fontSize: '0.875rem', // Slightly smaller body text size
      lineHeight: 1.5,
      color: '#6c757d', // Secondary text color for subtle text
    },
    button: {
      fontFamily: 'Roboto, sans-serif', // Secondary font for buttons
      textTransform: 'none', // Prevent uppercase text
    },
    caption: {
      fontFamily: 'Roboto, sans-serif', // Secondary font for captions
    },
    medium: {
      fontFamily: 'Poppins, sans-serif',
      fontWeight: 500,
    },
  },
  palette: {
    primary: {
      main: '#34495e',
    },
    secondary: {
      main: '#2c3e50',
    },
    text: {
      primary: '#2c3e50',// '#ecf0f1',
    },
  },
});

export default theme;